export default __webpack_public_path__ + "static/media/logo.02d6b457.svg";